import React from 'react';

import Link from '@dashboard/components/Link';

import PageEditView from '../../../../scenes/PageEdit/components/PageEditView';

import EventDescriptionForm from './components/EventDescriptionForm';
import FormEditForm from './components/EventDetailsForm';
import EventDiscountsForm from './components/EventDiscountsForm';
import EventMediaForm from './components/EventMediaForm';
import EventTicketTypesForm from './components/EventTicketTypesForm';

const PageEvent = () => {
  return (
    <PageEditView
      tabs={[
        {
          path: '/details',
          label: 'Details',
          component: <FormEditForm />,
        },
        {
          path: '/description',
          label: 'Description',
          component: <EventDescriptionForm />,
        },
        {
          path: '/image-gallery',
          label: 'Image gallery',
          component: <EventMediaForm />,
        },
        {
          path: '/ticket-types',
          label: 'Ticket types',
          description: (
            <>
              Add as many ticket groups and tickets as you like.{' '}
              <Link to="/help/articles/ticket-types-ticket-groups" blank>
                Learn more
              </Link>
            </>
          ),
          component: <EventTicketTypesForm />,
        },
        {
          path: '/bulk-discounts',
          label: 'Bulk discounts',
          description: <>Offer discounts based on the number of tickets purchased.</>,
          component: <EventDiscountsForm />,
        },
      ]}
    />
  );
};

export default PageEvent;
